import ChangeImgUtil from "../../../../engines/components/ChangeImgUtil";
import BaseStatePlusSprite from "../../../../engines/components/state/BaseStatePlusSprite";
import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import utilsModel from "../../../../engines/libs/utilsModel";
import utilsView from "../../../../engines/libs/utilsView";
import { FileKind } from "../../../define/FileKind";
import { MessageEventKind } from "../../../define/MessageEventKind";
import NormalGameManager from "../../manager/NormalGameManager";
import UserDataManage from "../../model/UserDataManage";
import cowItem, { CowIndexToSkin, cowRunType } from "./cowItem";

const { ccclass, property } = cc._decorator;
/**当前游戏状态 */
enum takeCowGameState {
    /**等待扔绳子 */
    waitThrowRope,
    /**扔出绳子 跑动画中 */
    throwRope,
    /**绳子未扔中牛 跑动画中 */
    unThrowRopeInCow,
    /**套中牛 扯动 */
    takePushCow,
    /**挣脱了 */
    struggle,
    /**扯成功 */
    takeIn
}
@ccclass
export default class takeCowPage extends cc.Component {
    private COWREWARD: number[] = [500000, 1000000,3000000, 5000000, 10000000, 50000000];
    /** 牛出现的概率 */
    private COWARISE:number[] = [20,20,15,15,15,15];
    /** 出现概率 */
    private COWARISE2:number[] = [20,20,20,20,20,20];
    /** 套中概率 */
    private COWINIT:number[] = [70,60,45,40,35,30];
    private COWINIT2:number[] = [100,100,100,100,100,100];
    private COWONCE:number[] = [1,1,1,1,1,1];
    /** 牛的移动速度 */
    private rMoveSpeed:number[] = [1, 1.5, 2, 2, 2.2, 2.2];
    /** 牛的移动速度 */
    private rMoveSpeed2:number[] = [1,1,1,1,1,1];
    @property({ type: cc.ProgressBar, displayName: "进度条" })
    pro_getCow: cc.ProgressBar = null;
    @property({ type: cc.Node, displayName: "获取牛进度节点" })
    node_getCow: cc.Node = null;
    @property({ type: cc.Node, displayName: "牛总节点" })
    node_cowGroup: cc.Node = null;
    @property({ type: cc.Node, displayName: "绳子总节点" })
    node_ropeGroup: cc.Node = null;
    @property({ type: cc.Node, displayName: "出手按钮" })
    node_btnchushou: cc.Node = null;
    @property({ type: cc.Node, displayName: "扯动按钮" })
    node_btnchedong: cc.Node = null;

    @property({ type: sp.Skeleton, displayName: "绳子动画" })
    spine_Rope: sp.Skeleton = null;

    @property({ type: sp.Skeleton, displayName: "挣扎动画" })
    sp_zhengzhacow: sp.Skeleton = null;
    @property({ type: sp.Skeleton, displayName: "晕动画" })
    sp_yuncow1: sp.Skeleton = null;

    @property({type:cc.Prefab,tooltip:"牛预制体"})
    cowP:cc.Prefab = null;

    @property(BaseStatePlusSprite)
    sprAdvanceCow: BaseStatePlusSprite = null;

    lastWave:number = -1;

    private type_key:string = "take-type-count-key";
    private type_day_key:string = "take-type-day-key";

    readonly MaxGetCowNum: number = 6;
    nowTakeCowIndex: number = 0;
    isOver: boolean = false;
    gameState: takeCowGameState = takeCowGameState.waitThrowRope;

    onLoad(){
        O1HD.on("takeCow.updateTakeCowAlreadly",this.updateTakeCowAlready,this);

        if (UserDataManage.instance.debugData.bHitCowDebug) {
            this.COWINIT = this.COWINIT2;
            this.COWARISE= this.COWARISE2;
            this.rMoveSpeed= this.rMoveSpeed2;
        }
    }

    start() {
        this.sprAdvanceCow.node.active = false;
        O1HD.getModules().uiControlModule.hideLoading();
        
        // this.waitThrowRope();
        NormalGameManager._instance.setGameData({isJoinTakeCow:true});
        O1HD.emit(MessageEventKind.EventName.UPDATE_CUPID_HOUSE_STATE);
        this.loadDay();
        this.updateAddRopeBtn();
        for (let i = 0, len = this.COWREWARD.length; i < len; i++) {
            this.node_getCow.children[i].getChildByName("lab").getComponent(cc.Label).string = data_control.getNumberFormat(this.COWREWARD[i], 0);
        }
        for (let i = 0, len = this.node_getCow.childrenCount; i < len; i++) {
            this.node_getCow.children[i].color = i > (this.nowTakeCowIndex - 1) ? cc.Color.GRAY : cc.Color.WHITE;
        }
        this.startGame();

        cc.tween(this.node_btnchedong)
            .repeatForever(
                cc.tween(this.node_btnchedong)
                    .to(0.3, { scale: 1.05 })
                    .to(0.3, { scale: 0.95 })
            )
            .start()
        this.updateTakeCowAlready();
    }
    @property({ type: cc.Node, displayName: "弹幕父节点" })
    startNode: cc.Node = null;
    @property({ type: ChangeImgUtil, displayName: "弹幕" })
    change_node: ChangeImgUtil = null;
    startGame() {
        this.startNode.active = true;
        this.startNode.opacity = 255
        this.change_node.changeImgById(8)
        cc.tween(this.startNode)
            .delay(1)
            .call(() => {
                this.change_node.changeImgById(7)
            })
            .delay(1)
            .call(() => {
                this.change_node.changeImgById(6)
            })
            .delay(1)
            .call(() => {
                this.change_node.changeImgById(9)
            })
            .to(0.5, { opacity: 0 })
            .call(() => {
                this.startNode.active = false;
                this.nexWave();
            })
            .start()
    }
    protected update(dt: number): void {
        this.lab_ropetimes.string = `X${this.nowRopeTime}`
    }
    @property({ type: cc.Label, displayName: "时间" })
    lab_time: cc.Label = null;
    @property({ type: cc.Label, displayName: "绳子次数" })
    lab_ropetimes: cc.Label = null;
    timeNum = 15;
    timeSche: () => void = null;
    waitThrowRopeState() {

        if (this.nowWave != 5) this.setChangjingAni(true);
        this.gameState = takeCowGameState.waitThrowRope
        this.setRopeAni(takeCowGameState.waitThrowRope)
        this.playShuaishengziSound();
        this.node_ropeGroup.resumeAllActions()
        this.canche = false;
        this.node_btnchedong.active = false;
        this.node_btnchushou.active = true;
        // // 开始计时
        // this.lab_time.string = `${this.timeNum}`;
        // let maxTime = this.timeNum;
        // if (this.timeSche) this.unschedule(this.timeSche);
        // this.timeSche = async () => {
        //     maxTime--;
        //     this.lab_time.string = `${maxTime}`;
        //     if (maxTime == 3) {
        //         this.playTimeConDown();
        //     }
        //     if (maxTime == 0) {
        //         // 时间到了 扣除次数
        //         if (this.timeSche) this.unschedule(this.timeSche);

        //         O1HD.getModules().uiControlModule.showMessageBox("甩绳子时间过长，消耗一根绳子");

        //         // 
        //         // let page: tipsPage;
        //         // let prams: TipsViewPrams = {
        //         //     title: `倒计时结束`,
        //         //     info: "甩绳子时间过长，消耗一根绳子",
        //         //     leftCall: () => {
        //         //         page && page.OnClickClose()
        //         //         // 直接结算
        //         //         //TODO 扣除次数

        //                 this.delRopeTimes(-1, () => { })
        //                 this.nowRopeTime--
        //                 this.isHasRopeTime((add: boolean) => {
        //                     if (add) {
        //                         this.waitThrowRopeState();
        //                     }
        //                 });
        //         //     },
        //         //     leftBtnStr: "确定",
        //         // }
        //         // page = await modules().uiControlModule.OpenPage("prefab/tipsPage", UI_Z_INDEX.DIALOG, prams, O1HD.getManagers().gameMgr.getCurrMode().bundle);

        //     }
        // }
        // this.schedule(this.timeSche, 1);

    }
    @property({ type: cc.Label, displayName: "次数减少" })
    lab_Add: cc.Label = null
    delRopeTimes(add: number, call: () => void) {

        this.lab_Add.node.active = true;
        this.lab_Add.string = add > 0 ? ("+" + add) : (add + "");
        this.lab_Add.node.stopAllActions();
        this.lab_Add.node.opacity = 255;
        this.lab_Add.node.getComponent(cc.LabelOutline).color = add > 0 ? new cc.Color().fromHEX("#489c71") : new cc.Color().fromHEX("#cc4f32");
        cc.tween(this.lab_Add.node)
            .delay(1)
            .to(0.5, { opacity: 0 })
            .call(() => {
                call && call()
            })
            .start()
    }
    // 点击按钮了 
    onClickTake() {
        if(this.nowRopeTime <=0){
            O1HD.getModules().uiControlModule.showMessageBox("没有绳子可用");
            return;
        }
        O1HD.getManagers().soundMgr.playSound('anNiu');
        switch (this.gameState) {
            case takeCowGameState.waitThrowRope:
                if (this.timeSche) this.unschedule(this.timeSche);
                this.stopTimeConDown();
                this.pauseShuaishengziSound();
                this.throwRope();
                break;
            case takeCowGameState.takePushCow:
                break;
            default: break;
        }
    }
    nowGetCowItem: cowItem = null;
    // 点击扔出绳子
    throwRope() {
        this.oncePro = 0;
        this.node_ropeGroup.pauseAllActions()
        O1HD.getManagers().soundMgr.playSound('cow_diushengzi',null,"takeCowGameBundle");
        this.gameState = takeCowGameState.throwRope;
        this.setRopeAni(takeCowGameState.throwRope, () => {
            // 扔出动画跑完之后 判断牛的位置
            let getCow: boolean = false;
            this.nowGetCowItem = this.getRopeCow()
            if (this.nowGetCowItem != null) getCow = true;
            this.setChangjingAni(false)
            if (getCow) {
                O1HD.getManagers().soundMgr.playSound('cow_tiaozhong',null,"takeCowGameBundle")
                this.gameState = takeCowGameState.takePushCow
                this.takePushCow();
            } else {
                if (this.nowWave == 1) this.onePause = true;
                this.gameState = takeCowGameState.unThrowRopeInCow
                this.setRopeAni(takeCowGameState.unThrowRopeInCow, () => {
                    // 没有套中牛 回收动画完成后 切换成待机

                    if (this.nowWave != 5) {
                        this.playcowRunSoundID();
                    }
                    for (let i = 0, len = this.cowList.length; i < len; i++) {
                        if (this.cowList[i] && this.cowList[i].node && this.cowList[i].node.isValid) {

                            this.cowList[i].sp_cow.node.active = true

                            this.cowList[i].runAni()
                            this.cowList[i].node.resumeAllActions();

                            this.cowList[i].changScale = true;
                            // this.cowList[i].node.scaleX = 1

                        }
                    }
                    if (this.nowWave == 1) this.onePause = false;
                    //TODO 扣除次数
                    this.delRopeTimes(-1, () => { })

                    this.setRopeTime(-1,true);
                    this.isHasRopeTime((add: boolean) => {
                        if (add) {
                            this.waitThrowRopeState();
                        }
                    });

                })
            }

        })
    }
    getRopeCow() {
        for (let i = 0, len = this.cowList.length; i < len; i++) {
            if (this.cowList[i] && this.cowList[i].node && this.cowList[i].node.isValid) {
                let head = this.cowList[i].node_head;
                if (Math.abs(this.node_ropeGroup.parent.convertToNodeSpaceAR(head.convertToWorldSpaceAR(cc.v2(0, 0))).x - this.node_ropeGroup.x) <= 100) {
                    return this.cowList[i];
                }
            }
        }
        return null
    }

    oncePro:number = 0;

    // 点击扯动绳子
    takePushCow() {
        if (this.nowWave == 1) {
            this.onePause = true;
        }

        let getcowCall: () => void = null

        // this.canche = false;
        // //  判断抓的这能不能抓
        // if (this.nowWave != 6) {
        // } else {
            // 第6波的时候
            this.canche = true;
            this.node_btnchedong.active = true;
            this.node_btnchushou.active = false;

        // }
        getcowCall = () => {


            let func = (zhong: boolean) => {
                //TODO 扣除次数
                this.delRopeTimes(-1, () => { })
                this.setRopeTime(-1,true);
                this.updateAddRopeBtn();
                this.addRopeBtnFun = null;
                if (zhong) {
                    // 切换成套中动画
                    this.gameState = takeCowGameState.takeIn
                    this.setRopeAni(takeCowGameState.takeIn, () => {

                        // this.getCow(this.nowGetCowItem.cowAniIndex)
                        this.takeCow();
                    })
                    this.scheduleOnce(this.nexWave, 5)

                } else {

                    // 不能被抓 牛回到原地
                    //TODO 如果还有绳子就接着往下走
                    this.gameState = takeCowGameState.struggle
                    this.setRopeAni(takeCowGameState.struggle, () => {
                        if (this.nowWave == 1) {
                            this.onePause = false;
                        }
                        
                        this.waitThrowRopeState()
                        this.isHasRopeTime((add: boolean) => {
                            if (add) {

                                if (this.nowWave != 5) {
                                    this.playcowRunSoundID();
                                }
                                for (let i = 0, len = this.cowList.length; i < len; i++) {
                                    if (this.cowList[i] && this.cowList[i].node && this.cowList[i].node.isValid) {
                                        this.cowList[i].node.active = true
                                        this.cowList[i].sp_cow.node.active = true
                                        this.cowList[i].runAni()
                                        this.cowList[i].node.resumeAllActions();

                                        this.cowList[i].changScale = true;
                                        // this.cowList[i].node.scaleX = 1

                                    }
                                }
                            }
                        });
                        // this.nowGetCowItem.node.active = true;
                        // this.nowGetCowItem.playAniChaoxiao();
                    })


                }
            }
            let taozhong: boolean = false;
            // if (this.nowWave != 6) {
                // let canpush = true;
                // switch (this.nowWave) {
                    // case 1:
                        // canpush = this.nowGetCowItem.cowAniIndex == 0;
                        let rand = Math.random() * 100;
                        taozhong = rand < this.COWINIT[this.nowWave] + this.oncePro;
                    //     break;
                    // case 2:{
                    //     taozhong = Math.random()< 0.8;
                    //     break;
                    // }
                    // case 3:{
                    //     taozhong = Math.random()< 0.7;
                    // }
                    // case 4:{
                    //     taozhong = Math.random()< 0.60;
                    //     break;
                    // }
                    // case 5:{
                    //     taozhong = Math.random()< 0.50;
                    //     break;
                    // }
                    // case 6:{

                    //     break;
                    // }
                // }
                // taozhong = canpush
                func(taozhong)
            // } 
            // else {

            //     taozhong = this.clickChe >= 5
            //     if (taozhong) {
            //         taozhong = Math.random() > 0.4;
            //     }

            //     func(taozhong)
            // }
        }


        this.setRopeAni(takeCowGameState.takePushCow, getcowCall)
        // 扯动牛 当前牛挣扎 其他牛停下来嘲笑
        if (this.nowWave != 5) {
            this.pausecowRunSoundID();
        }
        for (let i = 0, len = this.cowList.length; i < len; i++) {
            if (this.cowList[i] && this.cowList[i].node && this.cowList[i].node.isValid) {
                this.cowList[i].changScale = false;
                if (this.cowList[i].cowAniIndex == this.nowGetCowItem.cowAniIndex) {
                    // this.cowList[i].node.x = 0;
                    this.cowList[i].playAniZhengzha()
                    this.nowGetCowItem.node.active = false;
                } else {
                    this.cowList[i].playAniChaoxiao();
                    this.cowList[i].node.scaleX = this.cowList[i].node.x > this.node_ropeGroup.x ? 1 : -1
                }
            }
        }

    }
    canche: boolean = false;
    clickChe: number = 0
    onClickChedong() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        if (!this.canche) return;
        this.clickChe++;
        let once:number = this.COWONCE[this.nowWave];
        this.oncePro += once;
    }

    setRopeAni(state: takeCowGameState, downCall?: () => void) {
        // TODO:切换绳子动画
        let hasChangeAni: boolean = false;
        let needCall: boolean = false;
        switch (state) {
            case takeCowGameState.waitThrowRope:
                this.nowGetCowItem = null;
                this.spine_Rope.node.active = true;
                this.sp_zhengzhacow.node.active = false;
                this.sp_yuncow1.node.active = false;
                hasChangeAni = true;
                this.spine_Rope.setToSetupPose()
                this.spine_Rope.node.active = true;
                this.spine_Rope.setAnimation(0, "animation", true);
                // console.error("切换绳子动画为：等待扔绳子", state)
                break;
            case takeCowGameState.throwRope:
                this.spine_Rope.node.active = true;
                this.sp_zhengzhacow.node.active = false;
                this.sp_yuncow1.node.active = false;
                hasChangeAni = true;
                needCall = true;
                this.spine_Rope.node.active = true;
                this.spine_Rope.setToSetupPose()
                this.spine_Rope.setAnimation(0, "Pao", false);
                this.spine_Rope.loop = false
                // console.error("切换绳子动画为：扔绳子", state)
                break;
            case takeCowGameState.unThrowRopeInCow:
                this.spine_Rope.node.active = true;
                this.sp_zhengzhacow.node.active = false;
                this.sp_yuncow1.node.active = false;
                hasChangeAni = true;
                needCall = true;
                this.spine_Rope.setToSetupPose()
                this.spine_Rope.setAnimation(0, "Shou", false);
                // console.error("切换绳子动画为：未命中牛", state)


                for (let i = 0, len = this.cowList.length; i < len; i++) {
                    if (this.cowList[i] && this.cowList[i].node && this.cowList[i].node.isValid) {
                        this.cowList[i].changScale = false;
                        this.cowList[i].playAniChaoxiao(true);
                        this.cowList[i].node.scaleX = this.cowList[i].node.x > this.node_ropeGroup.x ? 1 : -1
                    }
                }
                break;
            case takeCowGameState.takePushCow:
                O1HD.getManagers().soundMgr.playSound('cow_tiaozhongjiao',null,"takeCowGameBundle")
                hasChangeAni = true;
                this.spine_Rope.node.active = false;
                this.sp_zhengzhacow.node.active = true;
                this.sp_yuncow1.node.active = false;
                this.sp_zhengzhacow.setToSetupPose()
                this.sp_zhengzhacow.setSkin(CowIndexToSkin[this.nowGetCowItem.cowAniIndex])
                this.sp_zhengzhacow.timeScale = this.nowWave == 5 ? 0.5 : 1
                this.sp_zhengzhacow.setAnimation(0, "animation", false);
                // console.log("????怎么回事>>>>");
                this.sp_zhengzhacow.setCompleteListener(() => {
                    // console.log("????怎么回事>>>>11111111111");
                    this.sp_zhengzhacow.clearTracks()
                    this.sp_zhengzhacow.setCompleteListener(null);
                    downCall && downCall();
                })
                // console.error("切换绳子动画为：命中牛，扯动", state)
                break;
            case takeCowGameState.struggle:

                // O1HD.getManagers().soundMgr.playSound('cow_tiaozhongjiao')
                hasChangeAni = true;
                this.spine_Rope.node.active = false;
                this.sp_zhengzhacow.node.active = true;
                this.sp_yuncow1.node.active = false;
                this.sp_zhengzhacow.setToSetupPose()
                this.sp_zhengzhacow.setSkin(CowIndexToSkin[this.nowGetCowItem.cowAniIndex])
                this.sp_zhengzhacow.setAnimation(0, "animation2", false);

                this.sp_zhengzhacow.setCompleteListener(() => {
                    O1HD.getManagers().soundMgr.playSound('cow_shengziduan',null,"takeCowGameBundle");
                    this.sp_zhengzhacow.clearTracks()
                    this.sp_zhengzhacow.setCompleteListener(null);
                    downCall && downCall();
                    this.spine_Rope.node.active = true;
                    this.sp_zhengzhacow.node.active = false;
                    this.sp_yuncow1.node.active = false;
                })


                // this.spine_Rope.node.active = true;
                // this.sp_zhengzhacow.node.active = false;
                // this.sp_yuncow1.node.active = false;
                // hasChangeAni = true;
                // needCall = true;
                // this.spine_Rope.setToSetupPose()
                // this.spine_Rope.setAnimation(0, "Shou", false);
                break;
            case takeCowGameState.takeIn:
                this.spine_Rope.node.active = true;
                this.sp_zhengzhacow.node.active = false;
                this.sp_yuncow1.node.active = false;
                hasChangeAni = true;
                this.spine_Rope.setToSetupPose()
                this.spine_Rope.setSkin(CowIndexToSkin[this.nowGetCowItem.cowAniIndex])
                this.spine_Rope.setAnimation(0, "Diao_Shang", false);
                this.spine_Rope.setCompleteListener(() => {
                    this.spine_Rope.clearTracks()
                    this.spine_Rope.setCompleteListener(null);
                    this.spine_Rope.setToSetupPose()
                    this.spine_Rope.setAnimation(0, "Diao_Xia", false);
                    downCall && downCall();
                    this.spine_Rope.setCompleteListener(() => {
                        O1HD.getManagers().soundMgr.playSound('cow_niudiao',null,"takeCowGameBundle");
                        this.spine_Rope.clearTracks()
                        this.spine_Rope.setCompleteListener(null);

                        this.spine_Rope.node.active = false;
                        this.sp_zhengzhacow.node.active = false;
                        this.sp_yuncow1.node.active = true;
                        this.sp_yuncow1.setToSetupPose()
                        this.sp_yuncow1.setSkin(CowIndexToSkin[this.nowGetCowItem.cowAniIndex])
                        this.sp_yuncow1.setAnimation(0, "animation", true);
                    })
                })
                break;
        }
        if (hasChangeAni && needCall) {
            this.spine_Rope.setCompleteListener(() => {
                this.spine_Rope.clearTracks()
                this.spine_Rope.setCompleteListener(null);
                downCall && downCall();
            })
            // downCall && downCall();
        }
    }
    // 套到牛了
    async takeCow() {
        if (this.isOver) return;
        // this.nowTakeCowIndex++;
        // 增加钱
        // console.log(this.nowWave,">>>>>>>>>>>>>")
        this.addOenWaveCow(this.nowWave);
        if (this.nowWave == 5) {
            // 第六个 展示选择界面
            this.unschedule(this.nexWave)
            this.scheduleOnce(()=>{
                this.showChat("放过我，我会报答你的！");
                this.scheduleOnce(()=>{
                    this.btnLayout.active = true;
                },1);
            },1);
        } else {
            let money = this.COWREWARD[this.nowWave];
            O1HD.getServices().userSrv.setCoins(money,true,this.node);
            // 获得指定的金钱奖励
        }
        // this.pro_getCow.progress = this.nowTakeCowIndex / this.MaxGetCowNum;
        // for (let i = 0, len = this.node_getCow.childrenCount; i < len; i++) {
        //     this.node_getCow.children[i].color = i > (this.nowTakeCowIndex - 1) ? cc.Color.GRAY : cc.Color.WHITE;
        // }
        // if (this.nowTakeCowIndex == this.MaxGetCowNum) {
        //     // this.gameOver(true)
        // }
    }
    async gameOver(win: boolean) {
        this.isOver = true;
        // console.error("游戏结束")
        if (!win) this.node && this.node.isValid && this.node.destroy()
        else {
            //TODO 结束 游戏胜利 动物已经被全部抓捕
        }
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound('anNiu');
        this.closeThis();
    }

    closeThis(){
        this.node && this.node.isValid && this.node.destroy()
    }

    getCow(cowIndex: number) {
        // console.error("抓到了牛", cowIndex)
    }
    //#region 波次
    nowWave: number = 0;
    cowList: cowItem[] = [];
    ropeActionTart: number = 11
    nexwaveDanmu(call: () => void) {
        
                call && call()
        // this.startNode.active = true;
        // this.startNode.opacity = 255
        // this.change_node.changeImgById(this.nowWave - 1)
        // cc.tween(this.startNode)
        //     .delay(1)
        //     .to(0.5, { opacity: 0 })
        //     .call(() => {
        //         call && call()
        //         this.startNode.active = false;
        //     })
        //     .start()
    }

    advanceShowCowHint(idx: number) {
        this.sprAdvanceCow.node.active = true;
        this.sprAdvanceCow.setFill(idx);

        cc.tween(this.sprAdvanceCow.node)
        .to(0.25, {opacity: 255})
        .delay(0.8)
        .to(0.25, {opacity: 0})
        .call(()=> {
            this.hideAdvanceHint();
        })
        .start();
    }

    hideAdvanceHint() {
        this.sprAdvanceCow.node.active = false;
    }

    nexWave() {
        this.nowWave = data_control.getRandIPosByWeights(this.COWARISE); //Math.floor(Math.random() * 6 + 1); //++;
        while(this.nowWave == this.lastWave){
            this.nowWave = data_control.getRandIPosByWeights(this.COWARISE);
        }
        let wave = this.nowWave + 1;
        this.lastWave = this.nowWave;
        for (let cowItem of this.cowList) cowItem.node.destroy();
        this.cowList = [];
        if (this.nowWave >= 7) {
            // 游戏赢了
            // this.gameOver(true)
            return
        }
        this.advanceShowCowHint(this.nowWave);
        this.nexwaveDanmu(() => {
            if (this.nowWave != 6) {
                this.playcowRunSoundID();
            }
            switch (wave) {
                case 1: this.oneWave(); break;
                case 2:
                    
                    this.newCow(cowRunType.two, this.rMoveSpeed[wave-1], 2, 1);
                    break;
                case 3:
                    this.newCow(cowRunType.two, this.rMoveSpeed[wave-1], 3, 2);
                    break;
                case 4:
                    this.newCow(cowRunType.two, this.rMoveSpeed[wave-1], 4, 3);
                    break;
                case 5:
                    this.newCow(cowRunType.two, this.rMoveSpeed[wave-1], 5, 4);
                    break;
                case 6:
                    this.newCow(cowRunType.two, this.rMoveSpeed[wave-1], 6, 5);
                    // 绳子开始左右
                    // cc.tween(this.node_ropeGroup)
                    //     .tag(this.ropeActionTart)
                    //     // .to(0.5, { x: -100 })
                    //     .repeatForever(
                    //         cc.tween()
                    //             .to(1, { x: 150 })
                    //             .to(1, { x: -150 })
                    //     )
                    //     .start()
                    break;
            }
            this.waitThrowRopeState();
        })

    }
    @property({ type: cc.Node, displayName: "场景节点" })
    node_changjing: cc.Node = null;
    speed: number = 100;
    ani: boolean = false;
    setChangjingAni(start: boolean = true) {
        if (this.ani && start) {
            this.node_changjing.children[0].resumeAllActions();
            this.node_changjing.children[1].resumeAllActions();
            return
        } else if (!start) {

            this.node_changjing.children[0].pauseAllActions();
            this.node_changjing.children[1].pauseAllActions();
            return
        }
        this.ani = true
        this.node_changjing.children[1].x = 0
        cc.tween(this.node_changjing.children[1])

            .repeatForever(
                cc.tween()
                    .to(8, { x: 750 })
                    .call(() => {
                        this.node_changjing.children[1].x = -750
                    })
                    .to(8, { x: 0 }))
            .start()
        this.node_changjing.children[0].x = -750
        cc.tween(this.node_changjing.children[0])
            .repeatForever(
                cc.tween()
                    .to(8, { x: 0 })
                    .to(8, { x: 750 })
                    .call(() => {
                        this.node_changjing.children[0].x = -750
                    }))
            .start()
    }
    maxRopeTime = 3;
    nowRopeTime = 3;
    // 每次消耗绳子 都判断一下是否还有次数
    async isHasRopeTime(call: (contin: boolean) => void) {
        if (this.nowRopeTime <= 0) {
            // console.error("没有绳子了！！！！");
            // 没有绳子了 展示增加绳子次数界面
            // let fun = (node:cc.Node)=>{
            //     let ns = node.getComponent(takeCowAddRopePage);
            //     let type = this.curType;
            //     if(type > 3) type = 3;
            //     ns.setType(type,this,()=>{
            //         this.nowRopeTime += 3;
            //         this.delRopeTimes(3, () => { })
            //         this.setCurType(type + 1);
            //         cc.director.resume();
            //         call(true);
            //     },()=>{
            //         cc.director.resume();
            //         call(false);
            //     });
            // }
            // utilsView.openPopupLayerTwo(
            //     FileKind.PrefabFilePath.takeCowGameAddRopeLayer,null,null,null,fun
            // );
            this.updateAddRopeBtn();
            this.addRopeBtnFun = call;

        } else {

            call(true)
        }
    }
    onePause: boolean = false;
    oneWave() {
        // for (let i = 0; i < 4; i++) {
        //     this.scheduleOnce(() => {
        //         this.newCow(cowRunType.one, 1, 1, i + 1);
        //     }, i * 3)
        // }
        // let time = 0;
        // let index = 0;
        // this.schedule(() => {
        //     if (this.onePause) return;
        //     time += 0.016;
        //     if (Math.floor(time / 2) >= index && index < 4) {
        //         this.newCow(cowRunType.one, 1, 1, index);
        //         index++
        //     }
        // }, 0.016)

        this.newCow(cowRunType.two, 1, 1, 0);

    }

    async newCow(runWay: cowRunType, speedBei: number, cowWave: number, cowIndex: number) {
        // 加载一头牛 按照下面的规则改一下
        let node = cc.instantiate(this.cowP);
        node.setParent(this.node_cowGroup)
        let src = node.getComponent(cowItem);
        this.cowList.push(src)
        await src.init(runWay, speedBei, cowWave, cowIndex);
        this.nexWave();
    }
    //#endregion

    //#region 音效cow_shuaishengzi
    TimeConDownID: number = null;
    playTimeConDown() {

        if (this.TimeConDownID == null) O1HD.getManagers().soundMgr.playSound('cow_TimeConDown',null,"takeCowGameBundle").then((id: number) => { this.TimeConDownID = id });
    }
    stopTimeConDown() {
        if (this.TimeConDownID != null) {
            O1HD.getManagers().soundMgr.stopSound(this.TimeConDownID)
            this.TimeConDownID = null
        }
    }

    shuaishengziSoundID: number = null;
    playShuaishengziSound() {

        if (this.shuaishengziSoundID == null) O1HD.getManagers().soundMgr.playSound('cow_shuaishengzi',null,"takeCowGameBundle", true).then((id: number) => { this.shuaishengziSoundID = id });
        else {
            cc.audioEngine.resume(this.shuaishengziSoundID)
        }
    }
    pauseShuaishengziSound() {
        if (this.shuaishengziSoundID != null) {
            cc.audioEngine.pause(this.shuaishengziSoundID)
        }
    }
    cowRunSoundID: number = null;
    playcowRunSoundID() {

        if (this.cowRunSoundID == null) O1HD.getManagers().soundMgr.playSound('cow_cowRunSoundID',null,"takeCowGameBundle", true).then((id: number) => { this.cowRunSoundID = id });
        else {
            cc.audioEngine.resume(this.cowRunSoundID)
        }
    }
    pausecowRunSoundID() {
        if (this.cowRunSoundID != null) {
            cc.audioEngine.pause(this.cowRunSoundID)
        }
    }
    //#endregion

    curType:number = 0;

    loadDay(){
        let dayStr:string = O1HD.getServices().localStorageSrv.getStorage(this.type_day_key);
        if(dayStr != data_control.getCurrDateDayString()){
            O1HD.getServices().localStorageSrv.setStorage(this.type_day_key,data_control.getCurrDateDayString());
            this.setCurType(1);
            this.setRopeTime(6,false);
        }
        this.loadCurType();
        this.loadRopeTime();
    }

    loadCurType(){
        this.curType = Number(O1HD.getServices().localStorageSrv.getStorage(this.type_key));
    }

    setCurType(type:number){
        O1HD.getServices().localStorageSrv.setStorage(this.type_key,type);
        this.curType = type;
    }

    @property({type:cc.Node,tooltip:"对话节点"})
    chatNode:cc.Node = null;

    showChat(chat:string){
        let chatLb:cc.Label = this.chatNode.getChildByName("lbChat").getComponent(cc.Label);
        chatLb.string = chat;
        this.chatNode.scale = 0;
        this.chatNode.active = true;
        cc.tween(this.chatNode).to(0.2,{scale:1},{easing:cc.easing.backOut}).start();
    }

    hideChat(){
        cc.tween(this.chatNode).to(0.2,{scale:0}).start();
    }

    @property({type:cc.Node,tooltip:"按钮layout"})
    btnLayout:cc.Node = null;

    onBtnSell(){
        this.btnLayout.active = false;
        O1HD.getServices().userSrv.setCoins(this.COWREWARD[this.nowWave],true,this.node);
        this.nexWave();
        this.hideChat();
        // this.closeThis();
    }

    async onBtnSave(){
        this.btnLayout.active = false;
        let addGoodsList = {};
        addGoodsList[50013] = 1;
        this.hideChat();
        await utilsView.openGetGoodsLayer(0, 0, addGoodsList);
        NormalGameManager._instance.onPushGoods(50013,1);
        this.nexWave();
        // 获得言字界面
        // this.closeThis();
    }

    @property({type:cc.Node,tooltip:"加绳子按钮"})
    btnAddRope:cc.Node = null;

    addRopeBtnFun:(isTrue:boolean)=>void

    onBtnAdddRope(){
        let type = this.curType;
        if(type > 3) type = 3;
        let needCoin:number = 0;
        switch(type){
            case 1:{
                needCoin = 1000000;
                break;
            }
            case 2:{
                needCoin = 2000000;
                break;
            }
            case 3:{
                utilsModel.loadAndShowVideoAdTrans(()=>{
                    
                    this.setRopeTime(3,true);
                    this.delRopeTimes(3, () => { })
                    this.setCurType(type + 1);
                    this.addRopeBtnFun && this.addRopeBtnFun(true);
                    this.updateAddRopeBtn();
                },()=>{
                    
                },null, '看广告获得绳子');
                return;
            }
        }
        let coin = O1HD.getServices().userSrv.getCoins();
        if(coin < needCoin){
            NormalGameManager._instance.openBankPage();
            return;
        }
        this.setRopeTime(3,true);
        this.delRopeTimes(3, () => { })
        this.setCurType(type + 1);
        O1HD.getServices().userSrv.setCoins(-needCoin,true);
        this.updateAddRopeBtn();
        this.addRopeBtnFun && this.addRopeBtnFun(true);
    }

    private ropeTimeKey:string = "rope-time-key";
    loadRopeTime(){
        this.nowRopeTime = Number(O1HD.getServices().localStorageSrv.getStorage(this.ropeTimeKey));
    }

    setRopeTime(count:number,isPlus:boolean){
        if(isPlus){
            this.nowRopeTime += count;
        }else{
            this.nowRopeTime = count;
        }
        O1HD.getServices().localStorageSrv.setStorage(this.ropeTimeKey,this.nowRopeTime);
    }

    updateAddRopeBtn(){
        if(this.nowRopeTime >0){
            this.btnAddRope.active = false;
            return;
        }
        this.btnAddRope.active = true;
        let type = this.curType;
        if(type > 3) type = 3;
        let videoIcon:cc.Node = this.btnAddRope.getChildByName("layout").getChildByName("video");
        let moneyNode:cc.Node = this.btnAddRope.getChildByName("layout").getChildByName("money");
        let moneyLabel:cc.Label = moneyNode.getChildByName("lbMoney").getComponent(cc.Label);
        let money:number = 0;
        moneyNode.active = false;
        videoIcon.active = false;
        switch(type){
            case 1:{
                moneyNode.active = true;
                money = 1000000;
                break;
            }
            case 2:{
                moneyNode.active = true;
                money = 1000000;
                break;
            }
            case 3:{
                videoIcon.active = true;
                break;
            }
        }
        moneyLabel.string = data_control.getNumberFormat(money);
    }

    protected onDisable(): void {
        O1HD.getManagers().soundMgr.stopAllEffects();
    }

    @property({type:cc.Node,tooltip:"套牛奖励界面"})
    takeCowAlready:cc.Node = null;

    /**
     * 更新套牛
     */
    updateTakeCowAlready(){
        this.takeCowAlready.children.forEach((n:cc.Node,index:number)=>{
            n.getChildByName("gray").active = NormalGameManager._instance.getGameData().takeCowAlreadyWave.includes(index);
        });
    }

    /**
     * 增加一个波次得牛
     * @param wave 波次
     */
    addOenWaveCow(wave:number){
        if(!NormalGameManager._instance.getGameData().takeCowAlreadyWave.includes(wave)){
            NormalGameManager._instance.getGameData().takeCowAlreadyWave.push(wave);
        }
        this.updateTakeCowAlready();
    }

    canClick:boolean = true;

    /**
     * 打开套牛合成界面
     */
    openTakeCowSynthesis(){
        if(!this.canClick){
            return;
        }
        this.canClick = false;
        if(NormalGameManager._instance.getGameData().takeCowAlreadyWave.length >= this.COWREWARD.length){
            //  可以获得奖励了
            let fun = (node:cc.Node)=>{
                this.canClick = true;
            }
            utilsView.openPopupLayerTwo(
                FileKind.PrefabFilePath.takeCowSynthesisPage,null,null,null,fun
            );
        }else{
            this.canClick = true;
            O1HD.getModules().uiControlModule.showMessageBox("收集牛牛样本，可兑换稀有称号");
        }
    }

}